import { ComponentPageNav } from '~/src/components/component-page-nav';
import StatusMenu from '~/src/components/status-menu';
import { AccessibilityLabel, StatusLabel } from '@primer/gatsby-theme-doctocat';
import { Label } from '@primer/react';
import { graphql } from "gatsby";
import * as React from 'react';
export default {
  ComponentPageNav,
  StatusMenu,
  AccessibilityLabel,
  StatusLabel,
  Label,
  graphql,
  React
};